module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "address-form"
  }, [_c('div', {
    staticStyle: {
      "height": "10px"
    }
  }), _vm._v(" "), _c('van-cell-group', [_c('van-field', {
    attrs: {
      "input-align": "right",
      "label": "联系人",
      "error": _vm.formValidate && !_vm.formData.name,
      "placeholder": "请输入联系人"
    },
    model: {
      value: (_vm.formData.name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "name", $$v)
      },
      expression: "formData.name"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "input-align": "right",
      "label": "手机号码",
      "error": _vm.formValidate && !_vm.formData.phone,
      "type": "number",
      "placeholder": "请输入手机号码"
    },
    model: {
      value: (_vm.formData.phone),
      callback: function($$v) {
        _vm.$set(_vm.formData, "phone", $$v)
      },
      expression: "formData.phone"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "input-align": "right",
      "readonly": "",
      "value": _vm.formData.province + _vm.formData.city + _vm.formData.county,
      "error": _vm.formValidate && !_vm.formData.county,
      "label": "选择地区",
      "placeholder": "请选择地区"
    },
    on: {
      "click": function($event) {
        _vm.area_show = true
      }
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "input-align": "right",
      "label": "详细地址",
      "type": "textarea",
      "error": _vm.formValidate && !_vm.formData.address,
      "placeholder": "请输入街道门牌信息"
    },
    model: {
      value: (_vm.formData.address),
      callback: function($$v) {
        _vm.$set(_vm.formData, "address", $$v)
      },
      expression: "formData.address"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "input-align": "right",
      "label": "邮政编码",
      "error": _vm.formValidate && !_vm.formData.phone,
      "type": "number",
      "placeholder": "请输入邮政编码"
    },
    model: {
      value: (_vm.formData.code),
      callback: function($$v) {
        _vm.$set(_vm.formData, "code", $$v)
      },
      expression: "formData.code"
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "是否设为默认"
    }
  }, [_c('van-switch', {
    attrs: {
      "size": "24px",
      "active-color": "#FCAB15"
    },
    model: {
      value: (_vm.switchCheck),
      callback: function($$v) {
        _vm.switchCheck = $$v
      },
      expression: "switchCheck"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "20px",
      "text-align": "center"
    }
  }, [_c('van-button', {
    staticClass: "save",
    attrs: {
      "round": "",
      "size": "large"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.formSave($event)
      }
    }
  }, [_vm._v("保存")])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "10px",
      "color": "#666",
      "text-align": "center"
    },
    on: {
      "click": _vm.onDelete
    }
  }, [_vm._v("\n    删除\n  ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.area_show),
      expression: "area_show"
    }],
    staticStyle: {
      "position": "fixed",
      "bottom": "0",
      "z-index": "1000",
      "width": "100%"
    }
  }, [_c('van-popup', {
    staticStyle: {
      "top": "50%"
    },
    attrs: {
      "position": "bottom",
      "close-on-click-overlay": false
    },
    model: {
      value: (_vm.show),
      callback: function($$v) {
        _vm.show = $$v
      },
      expression: "show"
    }
  }, [_c('van-area', {
    attrs: {
      "area-list": _vm.areaList,
      "value": _vm.formData.area_key
    },
    on: {
      "confirm": _vm.areaConfirm,
      "cancel": _vm.areaCancel
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6a491312","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/user/mine/address2/AddressEdit.vue
// module id = 2460
// module chunks = 0